var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoComic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.70518 0H0.0258789V5.81818H8.75315L6.70518 0Z",
    fill: "#68899A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4542 5.81818V0H9.28613L11.6241 5.81818H17.4542Z",
    fill: "#68899A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95512 14.1213H6.95511L1.15 14.1213V10.6031H16.3045V14.1213H6.95512Z",
    fill: "#68899A",
    stroke: "#68899A",
    strokeWidth: 2.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.47756 22.8517H3.47754L1.15 22.8518V19.3336H7.57727V22.8517H3.47756Z",
    fill: "#68899A",
    stroke: "#68899A",
    strokeWidth: 2.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9546 22.8517H13.9546L12.7862 22.8518V19.3336H16.3044V22.8517H13.9546Z",
    fill: "#68899A",
    stroke: "#68899A",
    strokeWidth: 2.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoComic);
export default __webpack_public_path__ + "static/media/ico-comic.3f4675b003ab0dcb9431d7973be3c2e4.svg";
export { ForwardRef as ReactComponent };